import React from 'react';
import styled from 'styled-components';
import { Icon as MaterialIcon} from '@material-ui/core';

const IconStyled = styled(MaterialIcon)`
  // custom css for icon goes here.
  // NOTE: this css styles will pe applied globally.
  

`;

const Icon = (props) => {
  
  return (
    <IconStyled {...props}>
        {props.name || props.children}
    </IconStyled>
  );
};
 
export default Icon;